import React, { Component } from 'react';
import { red, yellow, blue, green, grey } from '@mui/material/colors';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import OutlinedDiv from './Themes/Attributes/Styles/OutlinedDiv';
/**
 * @component
 * Modul zum Anzeigen von allgemeinen Nachrichten im AttributeEdit (im Gegensatz zum AttribiteMessageModul)
 */
class MessageModule extends Component {
  /**
   * @constructor
   * @param {*} params
   */
  constructor(params) {
    super();
    this.state = {
      type: '',
      message: '',
      detail: '',
      visible: false,
    };
  }

  componentDidMount() {
    this.onMounted(this);
  }

  /**
   *
   * @param {boolean} string true => ergebnis wird als String zurückgegeben
   * @return {string | object} Farbe die zu dem in den State gespeicherten Typ gehört
   */
  getColor(string) {
    const { type } = this.state;
    let color = grey;
    let colorString = 'grey';
    switch (type) {
      case 'error':
        colorString = 'red';
        color = red[500];
        break;
      case 'warning':
        colorString = 'yellow';
        color = yellow[500];
        break;
      case 'success':
        colorString = 'green';
        color = green[500];
        break;
      case 'info':
        colorString = 'blue';
        color = blue[500];
        break;
      case 'loading':
        colorString = 'yellow';
        color = grey[500];
        break;
      default:
        colorString = 'grey';
        color = grey[500];
    }
    if (string) return colorString;
    return color;
  }

  /**
   * @return {object} icon, welches zu dem in dem State gespeicherten Typ passt
   */
  getIcon() {
    const { type } = this.state;
    const fontSize = 40;
    switch (type) {
      case 'error': {
        return <ErrorIcon style={{ color: red[500], fontSize }} />;
      }
      case 'warning': {
        return <WarningIcon style={{ color: yellow[500], fontSize }} />;
      }
      case 'info': {
        return <InfoIcon style={{ color: blue[500], fontSize }} />;
      }
      case 'success': {
        return (
          <CheckCircleOutlineIcon style={{ color: green[500], fontSize }} />
        );
      }
      case 'loading': {
        return <CircularProgress style={{ color: green[500], fontSize }} />;
      }
      default: {
        return <ErrorIcon style={{ color: red[500], fontSize }} />;
      }
    }
  }

  /**
   * Setze Nachricht und zeige diese an
   * @param {string} type Typ der Nachricht ("error", "success", "info", "loading")
   * @param {string} message Nachricht (Kurz)
   * @param {string} detail Nachricht (Detail)
   */
  setMessage(type, message, detail) {
    this.setState({
      type,
      message,
      detail,
      visible: true,
    });
  }

  /**
   * Setze die Nachricht zurück und blende das Modul aus
   */
  reset() {
    this.setState({
      type: '',
      message: '',
      detail: '',
      visible: false,
    });
  }

  render() {
    const { onMounted } = this.props;
    const { message, detail, visible } = this.state;
    this.onMounted = onMounted;
    return (
      <div
        style={{
          borderStyle: 'solid',
          borderWidth: '1px',
          borderRadius: '5px',
          borderColor: this.getColor(true),
          minHeight: '50px',
          marginTop: '5px',
          marginBottom: '5px',
          display: visible ? 'block' : 'none',
        }}
      >
        <div style={{ float: 'left', margin: '4px' }}>{this.getIcon()}</div>
        <div>
          <div>{message}</div>
          <div>{detail}</div>
        </div>
      </div>
    );
  }
}
export default MessageModule;
